import React from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';

// 1. Perbaikan: Hapus const yang double
const blogArticles = [
    {
        id: 1,
        title: "Future of AI: Integrating Gemini in Web Apps",
        content: `Kecerdasan buatan bukan lagi masa depan, melainkan masa kini. Integrasi Gemini AI ke dalam aplikasi web...`,
        date: "15 Maret 2026",
        author: "Rony Saputra",
        category: "AI & Tech",
        image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=500"
    },
    {
        id: 2,
        title: "Modern UI/UX Trends for Developer Hubs",
        content: `Desain untuk developer membutuhkan keseimbangan antara estetika dan fungsionalitas. Glassmorphism memberikan kesan modern...`,
        date: "10 Maret 2026",
        author: "Rony Saputra",
        category: "Design",
        image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=500"
    },
    {
        id: 3,
        title: "React JS: Building Nexus Community Hub",
        content: `Membangun Nexus Community Hub dimulai dengan struktur komponen yang modular. Menggunakan React 18 dan Framer Motion...`,
        date: "5 Maret 2026",
        author: "Rony Saputra",
        category: "Development",
        image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?q=80&w=500"
    },
    {
        id: 4,
        title: "Cybersecurity 2026: Melindungi Data Xyrons",
        content: `Keamanan adalah prioritas utama di Xyrons Hub. Kami mengimplementasikan sistem enkripsi berlapis untuk keamanan data.`,
        date: "1 Maret 2026",
        author: "Admin Xyrons",
        category: "Security",
        image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=500"
    },
    {
        id: 5,
        title: "Evolusi GPU untuk AI Rendering",
        content: `Menjalankan model AI secara lokal membutuhkan hardware yang mumpuni. Kita akan membahas optimalisasi VRAM terbaru.`,
        date: "28 Feb 2026",
        author: "Rony Saputra",
        category: "Hardware",
        image: "https://images.unsplash.com/photo-1587202377425-991ae3a3e47a?q=80&w=500"
    },
    {
        id: 6,
        title: "Masa Depan Arsitektur Digital",
        content: `Dengan tools seperti Planner 5D dan Midjourney, proses rendering kini selesai dalam hitungan detik.`,
        date: "25 Feb 2026",
        author: "Admin Xyrons",
        category: "Architecture",
        image: "https://images.unsplash.com/photo-1600585154340-be6199f7f009?q=80&w=500"
    },
    {
        id: 7,
        title: "Prompt Engineering: Skill Wajib 2026",
        content: `Bukan hanya bertanya, tapi mengarahkan. Prompt engineering adalah seni memberikan instruksi presisi kepada AI.`,
        date: "22 Feb 2026",
        author: "Xyrons Bot",
        category: "Education",
        image: "https://images.unsplash.com/photo-1675271591211-126ad94e495d?q=80&w=500"
    },
    {
        id: 8,
        title: "Visi Komunitas Xyrons Hub",
        content: `Membangun ekosistem di mana setiap developer bisa berkontribusi dan berbagi ide kreatif secara global.`,
        date: "20 Feb 2026",
        author: "Rony Saputra",
        category: "Community",
        image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=500"
    },
    {
        id: 9,
        title: "Integrasi Smart Home dengan AI",
        content: `Teknologi otomasi rumah kini semakin pintar dengan integrasi API AI untuk kenyamanan hidup sehari-hari.`,
        date: "15 Feb 2026",
        author: "Tech Insider",
        category: "Smart Tech",
        image: "https://images.unsplash.com/photo-1558002038-103792e1798e?q=80&w=500"
    },
    {
        id: 10,
        title: "Tips Cloud Hosting untuk Project React",
        content: `Memilih platform deployment yang tepat sangat krusial untuk kecepatan akses pengguna di seluruh dunia.`,
        date: "10 Feb 2026",
        author: "Admin Xyrons",
        category: "Web Dev",
        image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=500"
    }
];

export default function Blog() {
    return (
        <div className="blog-container">
            <h2 className="blog-section-title">LATEST ARTICLES</h2>
            <div className="blog-list">
                {blogArticles.map((post) => (
                    <div key={post.id} className="blog-card">
                        <div className="blog-card-content">
                            <span className="blog-category">{post.category}</span>
                            <h3 className="blog-title">{post.title}</h3>
                            {/* 2. Perbaikan: Menggunakan post.content (bukan post.desc) */}
                            <p className="blog-desc">{post.content.substring(0, 100)}...</p>

                            <div className="blog-footer">
                                <div className="blog-meta-info">
                                    <span>📅 {post.date}</span>
                                    <span>👤 {post.author}</span>
                                </div>
                                <Link to={`/blog/${post.id}`} className="blog-read-more">
                                    Read More →
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}